import React, { useState, useRef, useEffect } from 'react'

import { useTranslation } from 'src/utils/i18n'
import { message } from 'antd'
import { updatePassword } from 'src/@api/login'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import { messageInfo } from 'src/components/Message'

const ChangePassword = () => {
  const { t } = useTranslation('common')

  const [password, setPassword] = useState('')
  const [nwePassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const changePassword = async () => {
    let text = ''
    if (password == '' || nwePassword == '' || confirmPassword == '') {
      text = t('form cannot be empty')
      messageInfo(text)

      return
    }
    if (nwePassword != confirmPassword) {
      text = t('The new password does not match')
      messageInfo(text)

      return
    }

    // 接口请求增加 try-catch 捕获，防止网络异常或服务端报错导致页面未捕获异常
    try {
      let result = await updatePassword({
        currentPassword: password,
        newPassword: nwePassword
      })

      if (result?.code == 0) {
        messageInfo(result.msg)
        setPassword('')
        setNewPassword('')
        setConfirmPassword('')
      } else {
        messageInfo(result?.msg || t('Operation failed'))
      }
    } catch (error) {
      // 优先展示后端 error.message；本地加密失败才用 error.message（未发请求）
      const backendMsg =
        error?.response?.data?.error?.message ||
        error?.response?.data?.msg ||
        error?.response?.data?.message
      messageInfo(backendMsg || error?.message || t('Operation failed'))
    }
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Settings')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[24px] pb-[30px]'>
        <h2 className='text-[#222222] text-[18px] text-center w-full font-[600]'>{t('Change Password')}</h2>
        <input
          className='w-full h-[36px] text-[12px] bg-[#F4F5F6] rounded-[30px] px-[30px] mt-[22px] mb-[15px]'
          type='password'
          placeholder={t('Current Password')}
          value={password}
          onChange={e => {
            setPassword(e.target.value)
          }}
        ></input>
        <input
          className='w-full h-[36px] text-[12px] bg-[#F4F5F6] rounded-[30px] px-[30px] mb-[15px]'
          type='password'
          placeholder={t('New Password')}
          value={nwePassword}
          onChange={e => {
            setNewPassword(e.target.value)
          }}
        ></input>
        <input
          className='w-full h-[36px] text-[12px] bg-[#F4F5F6] rounded-[30px] px-[30px] mb-[18px]'
          type='password'
          placeholder={t('Confirm Password')}
          value={confirmPassword}
          onChange={e => {
            setConfirmPassword(e.target.value)
          }}
        ></input>
        <button
          className={`w-full h-[42px] bg-[#FFCF55] rounded-[41px] text-[#1B1C2B] font-[600] ${password && nwePassword && confirmPassword ? '' : 'opacity-[0.6]'
            }`}
          disabled={password && nwePassword && confirmPassword ? false : true}
          onClick={changePassword}
        >
          {t('Change')}
        </button>
      </div>
    </>
  )
}

export default ChangePassword


